import { render, staticRenderFns } from "./VisaCardIcon.vue?vue&type=template&id=2a0c2265"
import script from "./VisaCardIcon.vue?vue&type=script&lang=js"
export * from "./VisaCardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports